/* eslint-disable max-lines */
/* eslint-disable import/no-default-export */
import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngTouch from 'angular-touch';
import ngCookies from 'angular-cookies';

import 'angular-min-max-validation';
import 'angular-i18n/angular-locale_ru.js';
import uiMask from 'angular-ui-mask';

import { getSearchParams } from './utils';

const ui = [
  require('@cian/ui/app/components/arrow/index.jsm').default,
  require('../blocks/Button').Button,
  require('@cian/ui/app/components/checkbox-wrapper/index.jsm').default,
  require('@cian/ui/app/components/click-outside/index.jsm').default,
  require('@cian/ui/app/components/compile-directive/index.jsm').default,
  require('@cian/ui/app/components/countdown/index.jsm').default,
  require('@cian/ui/app/components/dropdown/index.jsm').default,
  require('@cian/ui/app/components/email-subdomain-validator/index.jsm').default,
  require('@cian/ui/app/components/input-wrapper/index.jsm').default,
  require('@cian/ui/app/components/modal/index.jsm').default,
  require('@cian/ui/app/components/ng-form-submit/index.jsm').default,
  require('@cian/ui/app/components/preloader/index.jsm').default,
  require('@cian/ui/app/components/prevent-submit-on-enter/index.jsm').default,
  require('@cian/ui/app/components/radio-wrapper/index.jsm').default,
  require('@cian/ui/app/components/ruble/index.jsm').default,
  require('@cian/ui/app/components/switcher/index.jsm').default,
  require('@cian/ui/app/components/tabs/index.jsm').default,
  require('../blocks/textarea/index.jsm').default,
  require('@cian/ui/app/components/tooltip/index.jsm').default,
  require('@cian/ui/app/components/typeahead/index.jsm').default,
  require('@cian/ui/app/utils/format-number/index.jsm').default,
  require('@cian/ui/app/utils/model-to-number/index.jsm').default,
  require('@cian/ui/app/utils/parse-share-amount/index.jsm').default,
  require('@cian/ui/app/utils/validate-integer/index.jsm').default,
  require('@cian/ui/app/utils/validate-not-zero/index.jsm').default,
];

import cianPublishTerms from './../publish-terms/index.jsm';

// modules
import authModule from './../blocks/auth/auth.module';
import socialModule from './../blocks/social/social.module';
import feedbackAddressMap from './../blocks/modals/modal-report-address/map';
import addressInput from './../blocks/modals/modal-report-address/address-input';

// adapters
import modalAdapter from './../adapters/ui.bootstrap.modal/modal.module';

// segments directives
import aboutObjectDirective from './../blocks/segments/about-object/about-object.directive';
import aboutHouseDirective from './../blocks/segments/about-house/about-house.directive';
import aboutLandDirective from './../blocks/segments/about-land/about-land.directive';
import facilitiesDirective from './../blocks/segments/facilities/facilities.directive';
import adPlacingTermsDirective from './../blocks/segments/ad-placing-terms/ad-placing-terms.directive';
import adTypeDirective from './../blocks/segments/ad-type/ad-type.directive';
import authDirective from './../blocks/segments/auth/auth.directive';
import authLastStepComponent from './../blocks/segments/auth-last-step/auth-last-step.component';
import infrastructureDirective from './../blocks/segments/infrastructure/infrastructure.directive';
import infrastructureAndLeisureDirective from './../blocks/segments/infrastructure-and-leisure/infrastructure-and-leisure.directive';
import priceAndDealTermsDirective from './../blocks/segments/price-and-deal-terms/price-and-deal-terms.directive';
import thisObjectOnOtherWebsitesDirective from './../blocks/segments/this-object-on-other-websites/this-object-on-other-websites.directive';
import shortFormSwitcherDirective from './../blocks/segments/short-form-switcher/short-form-switcher.directive';
import rentHelperDirective from './../blocks/segments/rent-helper/rent-helper.directive';
import disabledWarningDirective from './../blocks/segments/disabled-warning/disabled-warning.directive';
import homeownerWarningDirective from './../blocks/segments/homeowner-warning/homeowner-warning.directive';
import getAdditionalBenefitsDirective from './../blocks/segments/get-additional-benefits/get-additional-benefits.directive';
import indexingDelayAlert from './../blocks/segments/indexing-delay-alert/indexing-delay-alert.directive';
import coworkingWorkplaceWarning from './../blocks/segments/coworking-workplace-warning/coworking-workplace-warning.directive';
import coworkingWorkplaceBanner from './../blocks/segments/coworking-workplace-banner/coworking-workplace-banner.directive';
import { AuctionHint } from '../blocks/AuctionHint';
import amenitiesDirective from './../blocks/segments/amenities/amenities.directive';
import commercialOwnershipVerification from './../blocks/segments/commercial-ownership-verification/commercial-ownership-verification.directive';
import adCommunicationTypeDirective from './../blocks/segments/ad-communication-type/ad-communication-type.directive';

// other directives
import adSegmentsDirective from './../blocks/ad-segments/ad-segments.directive';
import addFormDirective from './../blocks/add-form/add-form.directive';
import navigationDirective from './../blocks/navigation/navigation.directive';
import dynamicSegmentInputsDirective from './../blocks/dynamic-segment-inputs/dynamic-segment-inputs.directive';
import paymentStateDirective from './../blocks/payment-state/payment-state.directive';
import ngScopeElementDirective from './directives/ng-scope-element.directive';
import validatorNamesDirective from './directives/validator-names.directive';
import validatorInnDirective from './directives/validator-inn.directive';

// services
import adSegmentsService from './services/ad-segments.service';
import adStateService from './services/ad-state.service';
import adTooltipsService from './services/ad-tooltips.service';
import apiService from './services/api.service';
import apiRequestsUrlPrefixer from './services/api-requests-url-prefixer.interceptor';
import categoryService from './services/category.service';
import userService from './services/user.service';
import apiResponseErrorService from './services/http-response-error.interceptor';
import reportService from './services/report.service';
import adAssessmentService from './services/ad-assessment.service';
import headerPromoService from './services/header-promo.service';
import userIdentificationService from './services/user-identification.service';
import analyticsService from './services/analytics.service';
import homeownerService from './services/homeowner.service';
import { commercialOwnerService } from './services/commercialOwner.service';
import { formIdService } from '../../services/formId';
import advertiseObjectService from './services/advertise-object.service';
import geoService from './services/geo.service';
import StatsService from './services/stats.service.provider';
import { cardPaymentService } from './services/cardPayment';
import subdomainDraftService from './services/subdomain-draft.service';
import urlService from './services/url.service';
import ivrService from './services/ivr.service';
import { getAddFormMetaService } from './services/getAddFormMetaService';
import publishErrorTelemetryService from './services/publish-error-telemetry.service';
import deviceService from './services/device.service';
import excludeUtilitiesTermsRegionsService from './services/excludeUtilitiesTermsRegions.service';
import { PlanService } from './services/plan.service';
import { AdFieldsCleaningService } from './services/ad-fields-cleaning.service';
import { TelemetryService } from './services/telemetry.service';
import { coworkingService } from './services/coworking.service';
import { businessService } from './services/business.service';
import multiPostingService from './services/multiPosting.service';
import { getConfig } from '@cian/config/browser';

const getAllModulesInDirectory = req => {
  return req
    .keys()
    .reduce((modules, path) => [...modules, req(path).default], [])
    .filter(m => m); // filter modules which export nothing
};

const segments = [
  // подключаем файлы, оканчивающиеся на js и ts, за исключением *.d.js и *.d.ts
  ...getAllModulesInDirectory(
    require.context('./segment-inputs-config/common', true, /((?<!\.d)(?<!\.test))\.(js|ts)$/im),
  ),
  ...getAllModulesInDirectory(
    require.context('./segment-inputs-config/address', true, /((?<!\.d)(?<!\.test))\.(js|ts)$/im),
  ),
  ...getAllModulesInDirectory(
    require.context('./segment-inputs-config/about-object', true, /((?<!\.d)(?<!\.test))\.(js|ts)$/im),
  ),
  ...getAllModulesInDirectory(
    require.context('./segment-inputs-config/about-house', true, /((?<!\.d)(?<!\.test))\.(js|ts)$/im),
  ),
  ...getAllModulesInDirectory(
    require.context('./segment-inputs-config/about-land', true, /((?<!\.d)(?<!\.test))\.(js|ts)$/im),
  ),
  ...getAllModulesInDirectory(
    require.context('./segment-inputs-config/about-building', true, /((?<!\.d)(?<!\.test))\.(js|ts)$/im),
  ),
  ...getAllModulesInDirectory(
    require.context('./segment-inputs-config/price-and-deal-terms', true, /((?<!\.d)(?<!\.test))\.(js|ts)$/im),
  ),
  require('../blocks/icon-directive/icon-directive').default,
  require('../blocks/metro-icon/metro-icon.dir').default,
  require('../blocks/photo-upload/photo-upload.component').default,
  require('../blocks/mobile-click/mobile-click-directive').default,
  require('../blocks/dropdown/dropdown.directive').default,
  require('../blocks/plan-upload/plan-upload').default,
];

const dependencies = ui.concat([
  ngAnimate,
  ngTouch,
  ngCookies,
  cianPublishTerms,
  'ui.bootstrap.tooltip',
  'ui.bootstrap.stackedMap',
  'ui.bootstrap.modal',
  'minMaxValidations',
  uiMask,
  authModule,
  socialModule,
  feedbackAddressMap,
  addressInput,
  modalAdapter,
  ...segments,
]);

if (window.Raven) {
  dependencies.push('ngRaven');
}

// eslint-disable-next-line import/no-default-export
export default angular
  .module('cian.addForm', dependencies)
  // segments directives
  .directive('cianAfAboutHouse', aboutHouseDirective)
  .directive('cianAfAboutLand', aboutLandDirective)
  .directive('cianAfFacilities', facilitiesDirective)
  .directive('cianAfAboutObject', aboutObjectDirective)
  .directive('cianAfAdPlacingTerms', adPlacingTermsDirective)
  .directive('cianAfAdType', adTypeDirective)
  .directive('cianAfAuth', authDirective)
  .directive('cianAfAmenities', amenitiesDirective)
  .component('cianAfAuthLastStep', authLastStepComponent)
  .directive('cianAfInfrastructure', infrastructureDirective)
  .directive('cianAfInfrastructureAndLeisure', infrastructureAndLeisureDirective)
  .directive('cianAfPriceAndDealTerms', priceAndDealTermsDirective)
  .directive('cianAfThisObjectOnOtherWebsites', thisObjectOnOtherWebsitesDirective)
  .directive('cianAfShortFormSwitcher', shortFormSwitcherDirective)
  .directive('cianAfRentHelper', rentHelperDirective)
  .directive('cianAfDisabledWarning', disabledWarningDirective)
  .directive('cianAfHomeownerWarning', homeownerWarningDirective)
  .directive('cianAfGetAdditionalBenefits', getAdditionalBenefitsDirective)
  .directive('cianAfIndexingDelayAlert', indexingDelayAlert)
  .directive('cianAfAboutObjectCoworkingWorkplaceWarning', coworkingWorkplaceWarning)
  .directive('cianAfCoworkingWorkplaceBanner', coworkingWorkplaceBanner)
  .directive('cianAfCommercialOwnershipVerification', commercialOwnershipVerification)
  .directive('cianAfAdCommunicationType', adCommunicationTypeDirective)
  // other directives
  .directive('cianAfAdSegments', adSegmentsDirective)
  .directive('cianAfAddForm', addFormDirective)
  .directive('cianAfNavigation', navigationDirective)
  .directive('cianAfDynamicSegmentInputs', dynamicSegmentInputsDirective)
  .directive('cianAfPaymentState', paymentStateDirective)
  .directive('ngScopeElement', ngScopeElementDirective)
  .directive('cianAuctionHint', AuctionHint)
  // validators
  .directive('validatorNames', validatorNamesDirective)
  .directive('validatorInn', validatorInnDirective)
  // services
  .factory('adSegmentsService', adSegmentsService)
  .factory('adStateService', adStateService)
  .factory('adTooltipsService', adTooltipsService)
  .factory('apiService', apiService)
  .provider('categoryService', categoryService)
  .service('userService', userService)
  .service('geoService', geoService)
  .service('analyticsService', analyticsService)
  .factory('homeownerService', homeownerService)
  .factory('advertiseObjectService', advertiseObjectService)
  .provider('StatsService', StatsService)
  .factory('reportService', reportService)
  .factory('adAssessmentService', adAssessmentService)
  .factory('headerPromoService', headerPromoService)
  .service('userIdentificationService', userIdentificationService)
  .factory('cardPaymentService', cardPaymentService)
  .service('subdomainDraftService', subdomainDraftService)
  .service('urlService', urlService)
  .service('publishErrorTelemetryService', publishErrorTelemetryService)
  .factory('ivrService', ivrService)
  .service('getAddFormMetaService', getAddFormMetaService)
  .service('deviceService', deviceService)
  .service('excludeUtilitiesTermsRegionsService', excludeUtilitiesTermsRegionsService)
  .service('planService', PlanService)
  .service('adFieldsCleaningService', AdFieldsCleaningService)
  .service('telemetryService', TelemetryService)
  .service('coworkingService', coworkingService)
  .service('commercialOwnerService', commercialOwnerService)
  .service('formIdService', formIdService)
  .service('businessService', businessService)
  .service('multiPostingService', multiPostingService)

  .config([
    '$provide',
    '$compileProvider',
    '$httpProvider',
    '$uibTooltipProvider',
    'categoryServiceProvider',
    'uiMask.ConfigProvider',
    '$logProvider',
    (
      $provide,
      $compileProvider,
      $httpProvider,
      $uibTooltipProvider,
      categoryServiceProvider,
      uiMaskConfigProvider,
      $logProvider,
    ) => {
      const config = getConfig();
      const isDebugEnabled = config.get('addformConfig.debug');

      $compileProvider.debugInfoEnabled(isDebugEnabled);
      $provide.constant('isDebugMode', isDebugEnabled);
      $logProvider.debugEnabled(isDebugEnabled);

      $uibTooltipProvider.options({
        placement: window.serverAdaptiveFlags && window.serverAdaptiveFlags.isMobile ? 'top' : 'right',
        popupDelay: 0,
      });

      $httpProvider.interceptors.push(apiRequestsUrlPrefixer);
      $httpProvider.interceptors.push(apiResponseErrorService);
      $httpProvider.interceptors.push('retryInterceptor');
      $httpProvider.interceptors.push('latestBackendResponseInterceptor');

      // disable cache for get requests in IE
      if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
      }
      $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
      $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

      categoryServiceProvider.setSearch(getSearchParams());
      uiMaskConfigProvider.clearOnBlur(false);
    },
  ])
  .run([
    '$timeout',
    'telemetryService',
    function ($timeout, telemetryService) {
      $timeout(function () {
        telemetryService.mark('addform.init-start');
      });
    },
  ]);
